export function describeGeoError(err) {
  switch (err?.code) {
    case 1:
      return 'Permiso de ubicación denegado. Habilitalo en los ajustes del navegador y del dispositivo, y volvé a intentar.';
    case 2:
      return 'No se pudo determinar tu ubicación. Verificá que el GPS/ubicación del dispositivo esté activado.';
    case 3:
      return 'La búsqueda de ubicación tardó demasiado (frecuente en interiores). Probá al aire libre o reintentá.';
    default:
      return 'No se pudo obtener tu ubicación. Verificá permisos y GPS.';
  }
}
